import React, {Component} from 'react';
import {
  HitsStats,
  Layout,
  LayoutBody,
  LayoutResults,
  NoHits,
  Pagination,
  RefinementListFilter,
  SearchBox,
  SearchkitManager,
  SearchkitProvider,
  SortingSelector,
  ViewSwitcherHits
} from 'searchkit';
import './product_search';
import ProductListItem from './product_list_item';
import LayoutHeader from './LayoutHeader';
import Sidebar from './Sidebar';
import { H3 } from './styles/H3';

class ProductProvider extends Component {
  constructor(props) {
    super(props);
    this.searchkit = new SearchkitManager(props.searchEndpoint);
  }

  reloadSearch() {
    searchkit.reloadSearch();
  }

  render() {
    const searchEndpoint = this.props.searchEndpoint;

    return (
      <SearchkitProvider searchkit={this.searchkit}>
        <Layout>
          <LayoutHeader></LayoutHeader>
          <LayoutBody>
            <div className="uk-container uk-flex reverse-column">
              <LayoutResults>
                <ViewSwitcherHits
                  hitsPerPage={5}
                  highlightFields={['name', 'description']}
                  sourceFilter= {['name', 'photo_url', 'certification_url', 'city', 'tags', 'badges_urls', 'reviews_count', 'slug', 'category', 'subcategory', 'manufacturer', 'positive_ratings_count', 'negative_ratings_count', 'neutral_ratings_count']}
                  hitComponents= {[{key: 'list', title: 'List', itemComponent: ProductListItem}]}
                  scrollTo='body'
                />
                <NoHits suggestionsField={'name'}/>
                <Pagination showNumbers={true} pageScope={1}/>
              </LayoutResults>
              <Sidebar searchEndpoint={ searchEndpoint }/>
            </div>
          </LayoutBody>
        </Layout>
      </SearchkitProvider>
    );
  }
}

export default ProductProvider;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/product_provider.jsx